import httpHelper from "@/helpers/httpHelper";
// action types 
export const GET_NOTIFICATION_LIST = "getNotificationList";
// mutation types
export const SET_NOTIFICATION_LIST = "setNotificationList";

export default {
    state: {
        NotificationList: {},

    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedNotificationList(state) {
            return state.NotificationList;
        },


    },
    actions: {
        /**
         * Set the BankList 
         * @param state
         * @param payload
         */
        [GET_NOTIFICATION_LIST](context, payload) {
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData('dashboard-notifications')
                    .then((response) => {
                       if(response.success){
                        context.commit(SET_NOTIFICATION_LIST, response.result);
                        resolve(response.data);
                    }else{
                            this.$makeToast('danger','error',"server not respons for get notifications.",5000)
                    }
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => { });
            });
        },
    },
    mutations: {

        [SET_NOTIFICATION_LIST](state, payload) {
            state.NotificationList = payload;
        },

    }
};